module.exports = __webpack_public_path__ + "static/media/vyrez1.31287949.png";